module.exports = __webpack_public_path__ + "static/media/stripeIcon.9e56e9fa.png";